import { render } from "./markettrends-breadcrumb.vue?vue&type=template&id=36df32af"
import script from "./markettrends-breadcrumb.js?vue&type=script&lang=js"
export * from "./markettrends-breadcrumb.js?vue&type=script&lang=js"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__